import { render, staticRenderFns } from "./select-dep-tree.vue?vue&type=template&id=104aada8&scoped=true&"
import script from "./select-dep-tree.vue?vue&type=script&lang=js&"
export * from "./select-dep-tree.vue?vue&type=script&lang=js&"
import style0 from "./select-dep-tree.vue?vue&type=style&index=0&id=104aada8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104aada8",
  null
  
)

export default component.exports